import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss'],
})
export class ModalConfirmComponent {
  @Input() title: any;

  @Output() clickClose = new EventEmitter();
  @Output() clickDismiss = new EventEmitter();

  constructor(public activeModal: NgbActiveModal) {}

  btnClose(): void {
    this.clickClose.emit('save');
    this.activeModal.close();
  }

  btnDismiss(): void {
    this.clickDismiss.emit('dismiss');
    this.activeModal.dismiss();
  }
}
